
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parlor-place/[companyname]",
      function () {
        return require("private-next-pages/parlor-place/[companyname]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parlor-place/[companyname]"])
      });
    }
  